import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import { CreatePartnershipRequest } from '../types';

const becomePartnerApiUrl = '/BecomePartner';
export const partnerApiUrl = '/Partners';

const PostBecomePartnerRequest = (data: CreatePartnershipRequest) => nzApiAxios.post(becomePartnerApiUrl, data);
const GetPartnerRequest = (data: { tagId?: string }) =>
  nzApiAxios.get(partnerApiUrl, { params: data }).then((response) => response.data);
const GetPartnerTagsRequest = () => nzApiAxios.get(partnerApiUrl + '/tags').then((response) => response.data);

const API = {
  becomePartner: PostBecomePartnerRequest,
  getPartners: GetPartnerRequest,
  getTags: GetPartnerTagsRequest
};

export default API;
